export type InventoryMovementType =
  | 'check_out'
  | 'check_in'
  | 'transfer'
  | 'maintenance_out'
  | 'maintenance_in'
  | 'repair_out'
  | 'repair_in'
  | 'manual_adjustment'
  | 'inventory_count';

export type InventoryMovement = {
  id: string;
  companyId: string;
  inventoryItemId: string;
  type: InventoryMovementType;
  fromLocationId: string | null;
  toLocationId: string | null;
  reservationId: string | null;
  logisticsOrderId: string | null;
  maintenanceTaskId: string | null;
  quantity: number | null;
  notes: string;
  createdBy: string;
  createdAt: Date;
};

export type InventoryMovementInput = {
  inventoryItemId: string;
  type: InventoryMovementType;
  fromLocationId?: string | null;
  toLocationId?: string | null;
  reservationId?: string | null;
  logisticsOrderId?: string | null;
  maintenanceTaskId?: string | null;
  quantity?: number | null;
  notes?: string;
};

export type InventoryLocation = {
  id: string;
  companyId: string;
  name: string;
  description: string;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type InventoryLocationInput = {
  name: string;
  description: string;
  active: boolean;
};

export type MovementFilters = {
  type?: InventoryMovementType | 'all';
  inventoryItemId?: string;
  locationId?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
};

export type TimelineEntrySource =
  | 'movement'
  | 'reservation'
  | 'maintenance'
  | 'logistics';

export type TimelineEntry = {
  id: string;
  source: TimelineEntrySource;
  occurredAt: string;
  title: string;
  subtitle: string;
  typeLabel: string;
  entityId: string;
  metadata?: Record<string, string>;
};

export const MOVEMENT_TYPE_LABELS: Record<InventoryMovementType, string> = {
  check_out: 'Salida operativa',
  check_in: 'Devolución',
  transfer: 'Transferencia',
  maintenance_out: 'Salida a mantenimiento',
  maintenance_in: 'Retorno de mantenimiento',
  repair_out: 'Salida a reparación',
  repair_in: 'Retorno de reparación',
  manual_adjustment: 'Ajuste manual',
  inventory_count: 'Conteo físico',
};

/** Tipos que implican ítem fuera de ubicación fija (trazabilidad física). */
export const OUT_MOVEMENT_TYPES: readonly InventoryMovementType[] = [
  'check_out',
  'maintenance_out',
  'repair_out',
] as const;

export const IN_MOVEMENT_TYPES: readonly InventoryMovementType[] = [
  'check_in',
  'maintenance_in',
  'repair_in',
] as const;
